import React from 'react';
import { Container, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UnitedKingdomFlag from '#assets/img/flags/gb.svg';
import PlFlag from '#assets/img/flags/pl.svg';

const PublicLayout = ({ children }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className='min-vh-100 bg-light'>
      <Container className='py-4'>
        <div className='mb-4'>
          <div className='d-flex justify-content-between align-items-start align-items-md-center mb-3'>
            <div className='flex-grow-1 d-flex justify-content-start'>
              <div className='btn-group' role='group'>
                <button
                  type='button'
                  className={`btn btn-sm ${i18n.language === 'pl' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => changeLanguage('pl')}
                  title='Polski'
                >
                  <img src={PlFlag} width='20' alt='Polski' />
                </button>
                <button
                  type='button'
                  className={`btn btn-sm ${i18n.language === 'en' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => changeLanguage('en')}
                  title='English'
                >
                  <img src={UnitedKingdomFlag} width='20' alt='English' />
                </button>
              </div>
            </div>
            <div className='text-center flex-grow-1'>
              <Image src='/logo_new_2.svg' className='image-md' />
            </div>
            <div className='flex-grow-1'></div>
          </div>
        </div>
        {children}
      </Container>
    </div>
  );
};

export default PublicLayout;

